import React, { Component } from "react";
import { Link } from "react-router-dom";

class MinNav extends Component {

  render() {
    return (
      <div className="a-container">
        <div className="a-comp-btn">
          <Link to="/admin/user">
            <button>Users</button>
          </Link>
          <Link to="/admin">
            <button>Posts</button>
          </Link>
          <Link to="/admin/category">
            <button>Categories</button>
          </Link>
          <Link to="/admin/newsletter">
            <button>Newsletter</button>
          </Link>
          <Link to="/admin/editor/about">
            <button>About</button>
          </Link>
          <Link to="/admin/editor/privacy">
            <button>Privacy</button>
          </Link>
          <Link to="/admin/audio">
            <button>Audio Message</button>
          </Link>
        </div>
      </div>
    );
  }
}

export default MinNav;
